import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { LinkPresentational as LinkType } from '../../types/common';
import { LinkIntent, Link, LinkType as LinkTypeProps } from '../Link/Link';
import { Typography } from '../Typography/Typography';
import styles from './SearchTerms.module.css';

const messages = defineMessages({
  title: {
    id: 'src.components.SearchTerms.title',
    defaultMessage: 'Popular search terms',
  },
});

export type Props = {
  terms?: LinkType[];
};

export const SearchTerms: React.FC<Props> = React.memo(({
  terms,
}) => {
  return (
    <div className={styles.searchTerms}>
      <Typography variant='body2' className={styles.title}>
        <FormattedMessage {...messages.title} />
      </Typography>
      {
        terms ? terms.map(({ title, url }, idx) => (
          <Link
            key={`search-term_${idx}`}
            type={LinkTypeProps.Href}
            to={url.href}
            intent={LinkIntent.primary}
          >{ title }</Link>
        )) : null
      }
    </div>
  );
});

SearchTerms.displayName = 'SearchTerms';
